<!-- prettier-ignore -->

<ion-header class="register-header">
    <ion-toolbar>
        <span>{{'Regístrate' | translate}}</span>
        <ion-icon (click)="dismissModal()" name="close"></ion-icon>
    </ion-toolbar>
</ion-header>

<ion-content class="register-modal" [scrollEvents]="true" (ionScrollStart)="tools.toggleMenu($event)">

    <form class="register-form" [formGroup]="registerForm" (ngSubmit)="register()" #registerFormRef="ngForm">
        <p>{{'¡Te damos la bienvenida a Cicerone!' | translate}}</p>

        <div class="form-group-register" >
            <label class="labels">
                <span [ngClass]="{'error-color': registerFormRef.submitted && f.email.invalid}">{{'Correo electrónico' | translate}}</span> *
            </label>
            <div class="divInputStyle">
                <input autocomplete="off" [type]="'text'" (focusin)="focusin($event)" id="email" formControlName="email" class="inputs-pdf" />
            </div>

            @if(registerFormRef.submitted && f.email.invalid && (f.email.dirty || f.email.touched)){
                <div class="error-wrapper">
                    @if(f.email.errors.required){
                        <div>{{'Email es requerido' | translate}}</div>
                    }
                    @if(f.email.errors.email){
                        <div>{{'Email no válido' | translate}}</div>
                    }
                </div>
            }


        </div>

        <div class="form-group-register" >
            <label class="labels">
                <span>{{'Contraseña' | translate}}</span> *
            </label>
            <div class="divInputStyle">
                <input autocomplete="off" [type]="passwordType" (focusin)="focusin($event)" id="password" formControlName="password" class="inputs-pdf" />
                <ion-icon (click)="showPassword()" class="show-button" [name]="getIconStatus()"></ion-icon>
            </div>

            @if(registerFormRef.submitted && f.password.invalid && (f.password.dirty || f.password.touched)){
                <div class="error-wrapper" >
                    @if(f.password.errors.required){
                        <div>{{'Contraseña es requerida' | translate}}</div>
                    }
                    @if(f.password.errors.minlength){
                        <div>{{'Contraseña debe tener al menos 6 caracteres' | translate}}</div>
                    }
                </div>
            }

        </div>

        <div class="form-group-register" >
            <label class="labels">
                <span>{{'Confirma Contraseña' | translate}}</span> *
            </label>
            <div class="divInputStyle">
                <input autocomplete="off" [type]="passwordType" (focusin)="focusin($event)" id="confirmPassword" formControlName="confirmPassword" class="inputs-pdf" />
                <ion-icon (click)="showPassword()" class="show-button" [name]="getIconStatus()"></ion-icon>
            </div>

            @if(registerFormRef.submitted && registerForm.hasError('notSame') && (registerForm.get('confirmPassword').dirty || registerForm.get('confirmPassword').touched)){
                <div class="error-wrapper">
                    {{'Las contraseñas no coinciden' | translate}}
                </div>
            }

        </div>

        <div class="accept-terms">
            <input formControlName="checkBox" type="checkbox" name="check">
            <span (click)="openPrivacyModal()" [ngStyle]="{color: registerFormRef.submitted && !checkConditions ? 'red' : '#000'}">
                {{'He leído y acepto los términos y condiciones de uso' | translate}}
            </span>
        </div>
        
        <button type="submit" [disabled]="registerFormRef.submitted && registerForm.invalid" class="submit-button">{{'Registrar' | translate}}</button>

        <app-social-login-buttons [withDivider]="true" [termsAccepted]="checkConditions" intent="register"></app-social-login-buttons>
    </form>

</ion-content>